import css from 'styled-jsx/css';

const styles = css.global`#perguntas .perguntas-contain {
    margin-bottom: 48px;
}
@media (min-width: 992px) {
    #perguntas .perguntas-contain {
        margin-top: 0;
    }
    #perguntas {
        padding-top: 112px;
    }
  }

@media (min-width: 1280px) {
    .ctn-home-24 {
        padding-right: 0;
        padding-left: 0;
    }
  }`;

export default styles;